import { createContext, useContext } from "react";

// "device" continuously mirrors the OS/browser's own prefers-color-scheme setting (see index.js -
// it stays live for as long as the tab is open, not just recomputed on reload); "light"/"dark" are
// an explicit choice that overrides it regardless of what the device does afterwards. This lives
// in its own context (rather than Mantine's own useMantineColorScheme(), which only ever knows a
// resolved "light"/"dark" - it has no concept of "follow the device") so Profile's Appearance tab
// can read/change the 3-way mode without every layer in between having to thread it through as a
// prop just to reach it.
export const ColorSchemeModeContext = createContext({ mode: "device", setMode: () => {} });

export const useColorSchemeMode = () => useContext(ColorSchemeModeContext);
